import { createContext } from 'react'

import type { IDocumentsModalsContextData } from './types'

export const DocumentsModalsContext = createContext<IDocumentsModalsContextData | null>(null)
